exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".radio-group-radio-group-4Xs3clGLmwr div{position:relative;padding:5px 0}.radio-group-horizontal-6xj3wcahmwr{display:flex;flex-direction:row}.radio-group-horizontal-6xj3wcahmwr>div:not(:last-child){margin-right:20px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"radio-group": "radio-group-radio-group-4Xs3clGLmwr",
	"radioGroup": "radio-group-radio-group-4Xs3clGLmwr",
	"horizontal": "radio-group-horizontal-6xj3wcahmwr"
};